import { SpatialFilter } from '@carto/react-ui';
import { PolygonsResponse } from 'components/common/types/Polygon.types';

export const transformPolygonsResponse = (polygons: PolygonsResponse): Record<string, SpatialFilter[]> => {
  return polygons.reduce<Record<string, SpatialFilter[]>>((acc, curr) => {
    acc[curr.dealLineId] = curr.polygons.map((polygon) => ({
      type: 'Feature',
      polygonId: polygon.id,
      properties: {
        shape: polygon.shape !== 'Undefined' ? polygon.shape : null,
      },
      geometry: {
        type: 'Polygon',
        coordinates: [polygon.coordinates],
      },
    }));

    return acc;
  }, {});
};
